import React from "react";
import { pdf, Text, StyleSheet } from "@react-pdf/renderer";

import { SummaryDoc } from "./SummaryDoc";
import PDFMerger from "pdf-merger-js/browser";
import { DistributionDoc } from "./DistributionDoc";

const styles = StyleSheet.create({
  text: {
    margin: 12,
    fontSize: 14,
    textAlign: "justify",
    fontFamily: "Roboto",
  },
  boldText: {
    margin: 12,
    fontSize: 14,
    textAlign: "justify",
    fontFamily: "Roboto",
    fontWeight: "bold",
  },
});

export const ComboButton = (props) => {
  //const [doneDoc, setDoneDoc] = useState(null);

  function download(url, filename) {
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      })
      .catch(console.error);
  }

  async function downloadFullPdf() {
    let missed = [];
    const render = async (summaryPdf, nameOfPdf) => {
      //merge
      const merger = new PDFMerger();

      console.log("merging summary");
      await merger.add(summaryPdf);

      //merge dist chain doc
      const distPDF = await pdf(
        <DistributionDoc
          batchId={props.summary.batchId}
          mfrDate={props.summary.date}
          data={props.summary.distData}
          salesData={props.summary.salesData}
          notSM={!props.summary.isSM}
          title={true}
        />
      ).toBlob();

      await merger.add(distPDF);

      const urls = props.urls;
      console.log(urls);

      for (let i in urls) {
        console.log("merging pdf ", i);
        const url = urls[i].url;
        try {
          await merger.add(url);
        } catch (error) {
          console.log("unable to merge PDF... skipping to next");
          missed.push(i);
          console.log(missed);
        }
      }

      for (let i = 0; i < missed.length; i++) {
        if (i === 0) {
          alert(
            `Unable to merge Source Extract PDF${
              missed.length > 1 ? "(s)" : ""
            } ${missed.join(", ")}. ${
              missed.length > 1 ? "They" : "It"
            } will be downloaded seperately. Sorry for the inconveniance.`
          );
        }
        let urlObj = urls[missed[i]];
        download(urlObj.url, nameOfPdf + "-" + urlObj.name);
      }

      console.log("saving as blob");
      const mergedPdf = await merger.saveAsBlob();
      console.log("Downloading pdf");
      const url = URL.createObjectURL(mergedPdf);
      merger.save(`${nameOfPdf}-test-results`);

      console.log("url is: ", url);
    };

    const name = props.name.toUpperCase();
    const batch = props.batch.toUpperCase();

    const batchIsName = batch.localeCompare(name) === 0;
    let fullName = batchIsName ? batch : batch + "-" + name;
    //replace special chars with -
    fullName = fullName.replaceAll(/_|\.|:|\/| /g, "-");
    let parsedSummary = [];

    for (const [key, value] of Object.entries(props.summary)) {
      if (
        key.localeCompare("name") !== 0 &&
        key.localeCompare("date") !== 0 &&
        key.localeCompare("sourceMeds") !== 0 &&
        key.localeCompare("infoFields") !== 0 &&
        key.localeCompare("distData") !== 0 &&
        key.localeCompare("resultData") !== 0 &&
        key.localeCompare("ccURL") !== 0
      ) {
        let name = key.split(/(?=[A-Z])/);
        name[0] = name[0].charAt(0).toUpperCase() + name[0].slice(1);
        parsedSummary.push(
          <Text style={styles.text} key={key}>
            <Text style={styles.boldText}>{`${name.join(" ")}`}</Text>
            {`: ${value}`}
          </Text>
        );
      } else if (
        key.localeCompare("infoFields") === 0 ||
        key.localeCompare("resultData") === 0
      ) {
        //if info fields parse
        for (const [labelName, labelValue] of Object.entries(value)) {
          let name = labelName.split(/(?=[A-Z])/);
          name[0] = name[0].charAt(0).toUpperCase() + name[0].slice(1);
          parsedSummary.push(
            <Text style={styles.text} key={labelName}>
              <Text style={styles.boldText}>{`${name.join(" ")}`}</Text>
              {`: ${labelValue}`}
            </Text>
          );
        }
      }
    }

    const summaryPdf = await pdf(
      <SummaryDoc
        summary={parsedSummary}
        name={props.name}
        batch={props.batch}
        date={props.summary.date}
        sourceMeds={props.summary.sourceMeds}
      />
    ).toBlob();

    render(summaryPdf, fullName).catch((err) => {
      console.log(err);
      alert(
        "Unable to combine PDFs. Please download the zip or the individual PDFs. Sorry for the inconveniance"
      );
    });

    return null;
  }

  return (
    // <PDFViewer width={1000} height={500}>
    //   {doneDoc}
    // </PDFViewer>
    <button
      onClick={() => downloadFullPdf()}
      style={{ color: "white", margin: "8px", width: "225px" }}
    >
      Download as 1 PDF
    </button>
  );
};
